import { Duration } from 'luxon'

// More-specific (longer) suffixes must come before any suffix that is a
// trailing substring of them — endsWith() matches the first hit and returns.
const TOPIC_MAP = new Map([
  ['/bytes/received', 'bytes.received'],
  ['/bytes/sent', 'bytes.sent'],
  ['/clients/connected', 'clients.connected'],
  ['/clients/disconnected', 'clients.disconnected'],
  ['/clients/total', 'clients.total'],
  ['/messages/received', 'messages.received'],
  ['/messages/sent', 'messages.sent'],
  ['/publish/bytes/received', 'publish.bytes.received'],
  ['/publish/bytes/sent', 'publish.bytes.sent'],
  ['/publish/messages/dropped', 'publish.messages.dropped'],
  ['/publish/messages/sent', 'publish.messages.sent'],
  ['/retained messages/count', 'retained_messages.count'],
  ['/store/messages/bytes', 'store.messages.bytes'],
  ['/store/messages/count', 'store.messages.count'],
  ['/subscriptions/count', 'subscriptions.count'],
])

export function messageHandler(topic, message, vue) {
  // Handle uptime
  if (topic.includes('uptime')) {
    const seconds = message.match(/\d+/)?.[0]
    if (seconds) {
      vue.broker.uptime = formatUptime(seconds)
    }
    return
  }

  // Handle version
  if (topic.includes('version')) {
    vue.broker.version = message.replace('mosquitto version ', '')
    return
  }

  // Handle mapped topics using suffix matching
  for (const [suffix, propertyPath] of TOPIC_MAP) {
    if (topic.endsWith(suffix)) {
      setNestedProperty(vue.broker, propertyPath, message)
      return
    }
  }
}

function formatUptime(seconds) {
  const up = Duration.fromObject({ seconds: Number.parseInt(seconds) })
    .shiftTo('days', 'hours', 'minutes', 'seconds')
    .normalize()
    .toObject()

  const units = [
    { key: 'days', label: 'Days' },
    { key: 'hours', label: 'Hours' },
    { key: 'minutes', label: 'Minutes' },
    { key: 'seconds', label: 'Seconds' },
  ]

  return (
    units
      .filter((u) => up[u.key])
      .map((u) => `${up[u.key]} ${u.label}`)
      .join(', ') || '--'
  )
}

// Helper function to set nested property
function setNestedProperty(obj, path, value) {
  const keys = path.split('.')
  let current = obj

  for (let i = 0; i < keys.length - 1; i++) {
    current = current[keys[i]]
  }

  current[keys.at(-1)] = value
}
